import SVGIconWrapper from "./SVGIconWrapper"

const IconAngleUpBold = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 298.6"
        iconClass={`icon--angle-up-bold ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M250 0L0 250l48.6 48.6L250 97.2l201.4 201.4L500 250 250 0" />
    </SVGIconWrapper>
)

export default IconAngleUpBold